<template>
    <div class="spoofing-info">
        <hr1>Fraud Alerts</hr1>
        <div class="spoofing-head">
            <p>Call Spoofing Alert</p>
        </div>
        <div class="spoofing-para">
            <p> At Gold Star Mortgage , the security of your information is very important to us, and we want to help
                you keep it protected. Gold Star Mortgage has recently received reports from consumers of an increased
                volume in fraudulent calls that are attempting to appear as Gold Star Mortgage. Please remember that
                caller ID information can be faked to make you think that a call is coming from a trusted person or
                business. For more information on caller ID spoofing, read this blog post from the Federal Trade
                Commission:</p>
            <a href="https://www.consumer.ftc.gov/blog/scammers-can-fake-caller-id-info "
                class="consumerAlert__text--link website">https://www.consumer.ftc.gov/blog/scammers-can-fake-caller-id-info
            </a>
        </div>
        <div class="spoofing-para">
            <p>
                As a reminder, Gold Star Mortgage will not call you and ask for your account information or any other
                non-public personal information. If you receive a suspicious communication, do not respond, and do not
                use any contact information provided. If you wish to speak to someone directly and provide the details,
                please call our security department at <a href="tel:734-669-3047" aria-label="Gold Star Mortgage Financial Group, Security department"
                class="consumerAlert__text--link">734-669-3047</a>
            </p>
        </div>
    </div>
    <FooterComp></FooterComp>
</template>

<script>
import FooterComp from '@/components/Footer_Comp.vue';

export default {
    name: "ConsumerAlert",
    components: {
        FooterComp
    }
}
</script>
<style>
.spoofing-info{
    margin-top: 170px;
    justify-self: center;
    align-self: center;
    width: 80%;
    max-width: 1100px;
    line-height: 2;
    padding-bottom: 40px;
}
.spoofing-info hr1 {
    font-weight: bold;
    font-size: 2.4rem;
    color: #398c87;
}

.spoofing-info a {
    color: #0000ee;
    text-decoration: underline;
    border-top: none;
}

.spoofing-head{
    font-weight: bold;
    font-size: 1.2rem;
}

.spoofing-para{
    padding-bottom: 40px;
}
</style>